import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons';
import { IIssueMachineHealthResponse } from '@kcftech/prometheus-client';
import { DateTimeDisplay } from 'components/date_time/DateTimeDisplay';
import { PriorityLozenge } from 'pages/Desk/issues/issue_card/PriorityLozenge';
import { SeverityLozenge } from 'pages/Desk/issues/issue_card/SeverityLozenge';
import { IssueHierarchy } from 'pages/Desk/issues/issue_details/header/IssueName';
import { StatusLozenge } from 'pages/Desk/issues/StatusLozenge';
import { useIssueName } from 'pages/Desk/issues/useIssueName';
import {
    CreatedDate,
    DraftContainerLink,
    DraftContent,
    ExternalLinkIcon,
    FaultLocation,
    HeadingContainer,
    IssueTitle,
    Lozenges,
    LozengesRow,
    TopRow,
} from 'pages/Location/alerts_and_drafts/draft_issues/draft_issue_item/styled';

type DraftIssueItemProps = {
    issue: IIssueMachineHealthResponse;
    to: string;
};

export function DraftIssueItem({ issue, to }: DraftIssueItemProps) {
    const issueName = useIssueName(issue);

    return (
        <DraftContainerLink
            to={to}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`View draft issue #${issue.IssueNumber}`}
        >
            <DraftContent>
                <TopRow>
                    <HeadingContainer>
                        <IssueTitle>{issueName}</IssueTitle>
                        <ExternalLinkIcon icon={faExternalLinkAlt} />
                    </HeadingContainer>
                </TopRow>
                <FaultLocation>
                    <IssueHierarchy issue={issue} />
                </FaultLocation>
                <LozengesRow>
                    <Lozenges>
                        <SeverityLozenge severity={issue.Severity} />
                        <PriorityLozenge priority={issue.Priority} />
                        <StatusLozenge status={issue.IssueStatus.StatusType} />
                    </Lozenges>
                </LozengesRow>
                <CreatedDate>
                    <DateTimeDisplay date={issue.Created} showSeconds={false} />
                </CreatedDate>
            </DraftContent>
        </DraftContainerLink>
    );
}
